import { useTranslate } from "@refinedev/core";
import { SettingsTileCard, SparklesIcon } from "@fawkes/ui";

import { useModuleAvailability } from "../../../api/modules";
import type { TileComponentProps } from "./types";

// Registraties & Wizards — configurable registration wizards (steps + fields) with a dynamic tile on
// the animal. Shown in BOTH contexts (Jmix SettingsDashboardView: branch "Algemeen" + org "Dieren"),
// module-gated on `wizards`. Δ2 Phase 2: the api REST surface (GET/POST /api/wizard-definitions, incl.
// the publish/version lifecycle) + the in-SPA builder are built, so "Openen" opens the migrated detail
// in-place (WizardBuilderSettings) instead of handing off to the Jmix view — the additive strangler step
// (the Jmix /wizard-beheer view stays reachable but unused).
export const WIZARD_TILE_KEY = "wizards";

const ITEM_KEYS = ["instellingen.item.wizardsBeheren"];

export function WizardTile({ onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  const { isModuleEnabled } = useModuleAvailability();
  if (!isModuleEnabled("wizards")) return null;
  return (
    <SettingsTileCard
      tileKey={WIZARD_TILE_KEY}
      icon={<SparklesIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.wizards.title")}
      description={t("instellingen.tile.wizards.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("wizards")}
    />
  );
}
